"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminChildFoldersDataPayloadFromJSON = AdminChildFoldersDataPayloadFromJSON;
exports.AdminChildFoldersDataPayloadFromJSONTyped = AdminChildFoldersDataPayloadFromJSONTyped;
exports.AdminChildFoldersDataPayloadToJSON = AdminChildFoldersDataPayloadToJSON;
exports.AdminChildFoldersDataPayloadToJSONTyped = AdminChildFoldersDataPayloadToJSONTyped;
const runtime_1 = require("../runtime");
function AdminChildFoldersDataPayloadFromJSON(json) {
    return AdminChildFoldersDataPayloadFromJSONTyped(json, false);
}
function AdminChildFoldersDataPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'parentFolderId': !(0, runtime_1.exists)(json, 'parentFolderId') ? undefined : json['parentFolderId'],
    };
}
function AdminChildFoldersDataPayloadToJSON(value) {
    return AdminChildFoldersDataPayloadToJSONTyped(value, false);
}
function AdminChildFoldersDataPayloadToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'parentFolderId': value.parentFolderId,
    };
}
